export interface LanguageItem {
  code: string
  name: string
}

export interface LanguageInfo {
  key: string // 文案唯一标识; PT 自研和历史素材是通过 shortid 自生成的唯一标识，如果是新版 PS 制作的素材，则通过 Base64.encode 文本的 key 来生成的唯一标识，如果是坑位，则 Key 是 category id, 如果是动态参数名字、描述、选项，则 key 是 gameConfig 的 key;
  parent: string // 聚合的维度，如部分文案需要放在同一个 group 内时，需要通过这个字段聚合在一起，如 PT 里面的 scene/stage 属性值
  parentIndex?: number // 聚合的维度排序权重，值越少越靠前，如果不传这个值，降通过 parent 首字母进行排序
  value: string // 具体文案
}

// 当前项目的语言包 , key 为语言 code, value 为该语言下的所有文案数组
export interface LanguagePackage {
  [key: string]: Partial<LanguageInfo>[]
}

// 翻译状态： 0: 缺省状态; 1: 翻译中; 2: 翻译成功; 3: 翻译失败
export enum TranslationStatus {
  waiting,
  progressing,
  success,
  fail,
}

export interface LanguagePackageItems {
  key: string // 提取 LanguageInfo 的 key 值，作为 key
  checked: boolean // 是否勾选
  label: string // 当前原语言文案的 value 值
  value: string // 目标语言文案的 value 值
  status: TranslationStatus
}

// 当前项目的语言包列表
export type LanguagePackageLists = {
  label: string // 提取 LanguageInfo 的 parent 值，作为 label, 如果 parent 为空，则 label 为 __common__ 字符串
  children: LanguagePackageItems[]
}

// 为了兼容 elForm 的 model 结构，需要将 LanguagePackageLists 转换为对象，如果 label 为空字符串，则 key 为 0
export interface LanguagePackageModel {
  [key: number]: LanguagePackageLists
}
